// src/components/js/Contact.js
import React from 'react';
import { FaTelegramPlane, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../css/Contact.css';

const Contact = () => {
  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <p>Reach us through any of the following channels:</p>

      {/* Social Media Icons */}
      <div className="social-media-icons">
        <a
          href="https://t.me/badof1"
          target="_blank"
          rel="noopener noreferrer"
          className="icon telegram"
          aria-label="Telegram"
        >
          <FaTelegramPlane size={24} /> Telegram
        </a>

        <a
          href="mailto:badofirdo11@gmail.com"
          className="icon email"
          aria-label="Email"
        >
          <FaEnvelope size={24} /> Email
        </a>

        <a
          href="https://wa.me/251933992667"
          target="_blank"
          rel="noopener noreferrer"
          className="icon whatsapp"
          aria-label="WhatsApp"
        >
          <FaWhatsapp size={24} /> WhatsApp
        </a>
      </div>

      {/* Feedback guidance text */}
      <div className="feedback-guide">
        <p>👉 Want to leave feedback or a comment? Click the button below!</p>
      </div>

      {/* Feedback Button */}
      <div className="feedback-button-container">
        <Link to="/contact" className="contact-button feedback-button">
          Feedback
        </Link>
      </div>
    </div>
  );
};

export default Contact;

